import React from 'react'
import { Data, data } from '../content/table_data'
import { navigate } from 'gatsby'

interface Tag {
  text?: string
}

type StanceTag = Tag & { stance?: boolean }

const Approve: React.FC<Tag> = ({ text }) => {
  return <span className="text-sm font-medium bg-green-100 py-1 px-2 rounded text-green-500 align-middle">{text ?? 'Approve'}</span>
}
const Oppose: React.FC<Tag> = ({ text }) => {
  return <span className="text-sm font-medium bg-red-100 py-1 px-2 rounded text-red-500 align-middle">{text ?? 'Oppose'}</span>
}

const PolicyTag: React.FC<StanceTag> = ({ text, stance }) => {
  if (stance) {
    return <Approve text={text} />
  }

  return <Oppose text={text} />
}

const Table: React.FC = () => {
  const handleClick = (e: any, item: Data) => {
    if (item.page) {
      navigate(item.page)
    }
  }

  return (
    <div className="container max-w-3xl mx-auto mt-0 m-20">
      <table className="table-auto">
        <thead>
          <tr>
            <th className="px-4 py-2">Joe Biden</th>
            <th className="px-4 py-2">Policy (tap for more)</th>
            <th className="px-4 py-2">Bernie Sanders</th>
          </tr>
        </thead>

        <tbody>
          {data.map((item: Data, index: number) => (
            <tr
              className={item.page ? 'sm:cursor-pointer sm:hover:text-white sm:hover:bg-blue-400' : ''}
              onClick={e => handleClick(e, item)}
              key={`${index}`}
            >
              <td className="border px-4 py-2 text-center">
                <PolicyTag text={item.joeText} stance={item.joe} />
              </td>
              <td className="border px-4 py-2 text-center">{item.policy}</td>
              <td className="border px-4 py-2 text-center">
                <PolicyTag text={item.bernieText} stance={item.bernie} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Table
